module.exports = __webpack_public_path__ + "static/media/streamutt-white.c00d2438.png";